import { memo } from 'react';
import { Button, cn, useMedias } from '@divlab/divanui';

import { LikeSvg, BonusSvg } from './assets/Icons';
import useTranslation from '@Queries/useTranslation';
import { useRequest } from '@Contexts/Request';
import * as ModalWindows from '@Stores/ModalWindows';
import styles from './AuthorizationBanner.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface AuthorizationBannerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const AuthorizationBanner: FC<AuthorizationBannerProps> = (props) => {
  const { className, ...restProps } = props;
  const { isMobileM } = useMedias();
  const { language } = useRequest();
  const isKaz = language.id === 'kk';
  const { t } = useTranslation();

  const handleOpenModal = () => {
    ModalWindows.open('FavoritesAuth');
  };

  return (
    <div {...restProps} className={cn(styles.banner, className)} data-testid='auth-banner'>
      <div
        className={cn(styles.text, {
          [styles.textKz]: isKaz,
        })}
      >
        {t('ui.favorites.banner.auth')}
        <span className={styles.iconContainer}>
          <LikeSvg className={styles.icon} />
        </span>
        {!isMobileM && <br />}
        {t('ui.favorites.banner.bonuses')}
        <span className={styles.iconContainer}>
          <BonusSvg className={styles.icon} />
        </span>
        {t('ui.favorites.banner.for-purchases')}
      </div>

      <Button className={styles.button} onClick={handleOpenModal}>
        {t('ui.favorites.banner.button')}
      </Button>
    </div>
  );
};

export default memo(AuthorizationBanner);
